import React from "react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { organizeItems, pathwaySteps } from "../../data/content";
export function StorySection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-267" data-mp="bukm71ue2eqz">
      <div className="mx-auto max-w-3xl" data-id="element-268" data-mp="gtxa7pwzxrv5">
        <SectionHeading eyebrow="Why I created this" title={<>From looking at cases… <em className="text-gold-600" data-id="element-270" data-mp="kw21wj3vwef5">to analyzing them with a pathway</em></>} data-id="element-269" data-mp="guykhs66uabt" />

        <div className="mt-10 space-y-5 text-lg leading-relaxed text-ink/85" data-id="element-271" data-mp="puln2hanlm6g">
          <p data-id="element-272" data-mp="psimx4fseco0">You can study anatomy. You can watch surgical demonstrations. You can attend conferences. You can read papers.</p>
          <p className="font-serif text-2xl font-bold leading-snug text-navy-900" data-id="element-273" data-mp="zk59ty1hm06l">
            And still find yourself looking at a new blepharoplasty case asking: “Where exactly should I start?”
          </p>
          <p data-id="element-274" data-mp="18klbd1yo6x8t">
            Knowing more information and knowing how to <strong data-id="element-275" data-mp="18j0gfb8g1caf">organize</strong> that information are not always the same thing. When you’re looking at a new case,
            several things compete for your attention at the same time:
          </p>
        </div>

        <ul className="mt-6 grid grid-cols-2 gap-2.5 sm:grid-cols-3" data-id="element-276" data-mp="1lrzlrtfn5jmv">
          {organizeItems.map(item => <li key={item} className="rounded-xl bg-navy-100 px-4 py-3 text-center text-[15px] font-semibold text-navy-900" data-id="element-277" data-mp="1gt4u01zp4kqm">
              {item}
            </li>)}
        </ul>

        <p className="mt-6 text-lg leading-relaxed text-ink/85" data-id="element-278" data-mp="29hk7gk36iuzu">
          And suddenly, instead of having a clear process, you find yourself jumping from one thought to another. I didn’t want to create another
          massive library of information — I wanted something you could <strong data-id="element-279" data-mp="1zpo6n19pkqrx">actually use with a case in front of you.</strong>
        </p>

        <div className="mt-10 rounded-3xl bg-navy-900 p-6 sm:p-10" data-id="element-280" data-mp="2x8phujqcov2r">
          <p className="text-center text-sm font-bold uppercase tracking-[0.14em] text-gold-400" data-id="element-281" data-mp="2sg64nnvks1yh">A simple sequence</p>
          <ol className="mt-5 grid grid-cols-1 gap-2 md:grid-cols-7 md:gap-1" data-id="element-282" data-mp="qk72jg8ft03m">
            {pathwaySteps.map((step, i) => <li key={step.name} className="flex items-center gap-3 rounded-xl bg-navy-800 px-4 py-3 md:flex-col md:gap-1 md:px-1 md:py-4 md:text-center" data-id="element-283" data-mp="vk1snhke1lnm" data-mpi={i}>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gold-500 font-serif text-base font-bold text-navy-900" data-id="element-284" data-mp="lre0x189m7vr">{i + 1}</span>
                <span className="text-base font-bold uppercase tracking-wide text-white md:text-[11px] md:tracking-normal" data-id="element-285" data-mp="btzqbi90wdbd">{step.name}</span>
              </li>)}
          </ol>
          <p className="mt-6 text-center text-base leading-relaxed text-white/80" data-id="element-286" data-mp="3u1xnngo8vefr">
            The goal isn’t to replace your clinical judgment. It’s a repeatable educational framework for practicing how you organize your thinking.
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-287" data-mp="1x5zxrmw0t8hp">
          <CTAButton label="I want to analyze cases with a system" data-id="element-288" data-mp="3hpd69iz6wsx7" />
        </div>
      </div>
    </section>;
}